"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portalContainsElement = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "portalContainsElement", { enumerable: true, get: function () { return dom_utilities_1.portalContainsElement; } });
//# sourceMappingURL=portalContainsElement.js.map